import { render, staticRenderFns } from "./RoomTypeCard.vue?vue&type=template&id=c6e0b092"
import script from "./RoomTypeCard.vue?vue&type=script&lang=ts"
export * from "./RoomTypeCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports